<template>
    <vx-box
        color="white"
        class="flex flex-col relative p-6 gap-5 grow"
        :class="{ 'justify-between': loading }"
        :style="{
            minHeight: props.minHeight,
        }"
    >
        <div class="z-0 flex flex-col justify-between gap-4 md:flex-row">
            <div class="space-y-px">
                <div class="flex items-baseline gap-2">
                    <span class="z-30 flex items-center justify-between font-semibold text-slate-800">
                        {{ props.category.label }}
                    </span>
                    <font-awesome-icon widthAuto :icon="props.category.icon" class="text-sm text-slate-400" />
                </div>

                <p class="text-xs leading-normal tracking-wide text-slate-500">
                    {{ props.category.description }}
                </p>
            </div>

            <vx-button :href="props.href" :disabled="loading" size="sm" color="muted-light">
                Details <font-awesome-icon widthAuto :icon="faSquareArrowUpRight" />
            </vx-button>
        </div>

        <card-loading-bars :loading="loading" />

        <slot></slot>
    </vx-box>
</template>

<script setup>
import { VxBox, VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSquareArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import CardLoadingBars from '../CardLoadingBars.vue';

const props = defineProps({
    category: {
        type: Object,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    minHeight: {
        type: String,
        default: '200px',
    },
    href: {
        type: String,
    },
});
</script>
